import { Radio } from 'antd'
import type { OrderManagementGridView } from '../../../All/types'

type OrderTankToggleProps = {
  selectedView: OrderManagementGridView
  setSelectedView: (view: OrderManagementGridView) => void
}

export function OrderTankToggle({ selectedView, setSelectedView }: OrderTankToggleProps) {
  return (
    <Radio.Group
      value={selectedView}
      onChange={(e) => setSelectedView(e.target.value)}
      optionType='button'
      buttonStyle='solid'
    >
      <Radio.Button value='order'>By Order</Radio.Button>
      <Radio.Button value='tank'>By Tank</Radio.Button>
    </Radio.Group>
  )
}
